import { Component, OnInit, ViewChild } from '@angular/core';
import { DocumentPendingBatcheAvaliableStock, EDocumentTypeNature, Product } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { ProductsStorageService } from '../../product-storage.service';
import { firstValueFrom, take, takeUntil } from 'rxjs';
import { GenericReadOnlyResource, MemoryReadOnlyResource } from 'src/app/resources';
import { ITabComponent, TabRole, TabsService } from 'src/app/libs/components/tabs-host/tabs.service';
import { OmsPurchaseOrdersEditComponent } from '../../../../../oms/logistics/oms-purchase-orders/oms-purchase-orders-edit/oms-purchase-orders-edit.component';
import { OmsSalesOrdersEditComponent } from '../../../../../oms/logistics/oms-sales-orders/oms-sales-orders-edit/oms-sales-orders-edit.component';
import { OmsManufacturingOrdersEditComponent } from '../../../../../oms/production/oms-manufacturing-orders/oms-manufacturing-orders-edit/oms-manufacturing-orders-edit.component';
import { DxDataGridComponent } from 'devextreme-angular';

@Component({
    selector: 'app-product-document-pending-batch',
    templateUrl: './product-document-pending-batch.component.html',
    styleUrl: './product-document-pending-batch.component.sass',
    standalone: false
})
export class ProductDocumentPendingBatchComponent implements OnInit{
  product?: Product;
  productBatches?: GenericReadOnlyResource<DocumentPendingBatcheAvaliableStock>;
  @ViewChild('gridPrices', { static: false }) gridPrices?: DxDataGridComponent;

    constructor(
       private api: MasterApiService,
       private productData: ProductsStorageService,
       private tabs: TabsService
    ){

    }
    async ngOnInit(): Promise<void> {
      this.product = this.productData.entity;
      this.productBatches = this.api.resources.operations.documentPendingBatchesAvaliableStock.contextualizeQueryParams({ 'ProductId': this.product!.id.toString() })
    }
    navigateToDocumentEditor(item: DocumentPendingBatcheAvaliableStock): void {
      let tab: ITabComponent<any> | undefined = undefined;
      if(item.documentTypeDiscriminator === EDocumentTypeNature.PurchaseOrder){
        tab = this.tabs.createTab(OmsPurchaseOrdersEditComponent, TabRole.EDITION, {
          inputPrms: {
            id: item.documentId,
          }
        });
      }
      if(item.documentTypeDiscriminator === EDocumentTypeNature.SalesOrder){
        tab = this.tabs.createTab(OmsSalesOrdersEditComponent, TabRole.EDITION, {
          inputPrms: {
            id: item.documentId,
          }
        });
      }
      if(item.documentTypeDiscriminator === EDocumentTypeNature.ProductionOrder){
        tab = this.tabs.createTab(OmsManufacturingOrdersEditComponent, TabRole.EDITION, {
          inputPrms: {
            id: item.documentId,
          }
        });
      }
      if(tab !== undefined){

        tab.component.instance.entityChanged.subscribe(async () => {
          await this.gridPrices?.instance.refresh();
          tab!.close();
        });
      }
      }

}
